import { ReadLeaveRequestPeriodCheck } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import { periodLabel } from './periodLabel';

export type AllowanceSeverity = 'error' | 'warning';

export interface LeaveAllowanceMessages {
  daysToTake: (days: number) => string;
  exceeded: (check: ReadLeaveRequestPeriodCheck, label: string) => string;
  remaining: (check: ReadLeaveRequestPeriodCheck, label: string) => string;
  exceededSeverity: AllowanceSeverity;
}

const SEVERITY_CLASSES: Record<AllowanceSeverity, string> = {
  error: 'font-semibold text-red-600',
  warning: 'font-semibold text-amber-700'
};

export interface LeaveAllowanceCheckBaseProps {
  checks: ReadLeaveRequestPeriodCheck[];
  daysToTake: number;
}

interface LeaveAllowanceCheckProps extends LeaveAllowanceCheckBaseProps {
  messages: LeaveAllowanceMessages;
}

export const LeaveAllowanceCheck: FC<LeaveAllowanceCheckProps> = ({ checks, daysToTake, messages }) => (
  <div className="flex flex-col gap-1 text-sm">
    <p>{messages.daysToTake(daysToTake)}</p>
    {checks.map(c => {
      const label = periodLabel(c);
      return c.exceeds ? (
        <p key={c.periodStart} className={SEVERITY_CLASSES[messages.exceededSeverity]}>
          {messages.exceeded(c, label)}
        </p>
      ) : (
        <p key={c.periodStart}>{messages.remaining(c, label)}</p>
      );
    })}
  </div>
);
